function Show({ when, children }) {
  if (!when) {
    return <></>;
  }

  return <>{children}</>;
}

export default Show;
